import { format, differenceInCalendarDays, type Locale } from 'date-fns';

/** Just enough of i18next's `t` to read the three relative-day strings. */
type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * When a send happened, as a climber would say it: today, yesterday, "3 days
 * ago", then a plain date.
 *
 * Counted in calendar days rather than in elapsed hours on purpose —
 * `topped_at` is stored at midnight UTC (it is a date, not a moment), so an
 * exact-timestamp diff reads "16 hours ago" for something sent this morning.
 */
export function formatSendDate(dateString: string, t: Translate, locale: Locale): string {
  const date = new Date(dateString);
  const diffDays = differenceInCalendarDays(new Date(), date);

  if (diffDays === 0) return t('sends.today');
  if (diffDays === 1) return t('sends.yesterday');
  if (diffDays < 7) return t('sends.daysAgo', { count: diffDays });

  return format(date, 'MMM d, yyyy', { locale });
}
